import React, { Component, PropTypes } from 'react';
import CargoDescription from 'components/CargoDescriptionControl';
import ActionCreators from 'actions/ActionCreators';
import { CargoType, CategoryType } from 'types';
import ga from 'react-ga';
import Button from 'components/ButtonControl';
import CargoPhotoControl from 'components/CargoPhotoControl';
import ShallowCompare from 'react-addons-shallow-compare';
import CargoPhotoList from 'components/CargoPhotoList';

import './CommonCargoAttributesPane.scss';

class CommonCargoAttributesPane extends Component {

    static propTypes = {
        onChange: PropTypes.func,
        selectedCategory: PropTypes.instanceOf(CategoryType).isRequired,
    };

    constructor(props) {
        super(props);

        this.state = {
            showCommentButton: true,
            showCommentField: false
        };
    }

    shouldComponentUpdate(nextProps, nextState) {
        return ShallowCompare(this, nextProps, nextState);
    }

    _toggleField = () => {
        this.setState({
            showCommentField: !this.state.showCommentField,
            showCommentButton: !this.state.showCommentButton
        });

        ga.event({
            category: 'buttons',
            action: 'fill_cargo',
            label: 'add_comment',
            value: 1
        });

    };

    _onDescriptionChange = (event) => {
        ActionCreators.updateEditingCargo({
            'comment': event.target.value
        });
    };

    componentWillMount() {
        if (this.props.commentValue) {
            this.setState({
                showCommentField: true,
                showCommentButton: false
            });
        }
    };

    render() {
        var title = 'Добавьте описание груза';
        if (this.props.hasPhotoAttribute) {
        	title = 'Добавьте фото и описание груза';
        };
        if (this.props.selectedCategory.id === 'people') {
        	title = 'Добавьте описание перевозки';
        };
        var commentButton = null;

        if (this.state.showCommentButton && this.props.hasCommentAttribute) {
            commentButton = (
                <Button
                    className="CommonCargoAttributesPane-commentButton"
                    view="stone"
                    size="s"
                    onClick={ this._toggleField }>
                    Добавить описание
                </Button>
            );
        }

        var description = null;
        if (this.props.hasCommentAttribute) {
            description = (
                <CargoDescription
                    show={ this.state.showCommentField }
                    onChange={this._onDescriptionChange}
                    value={ this.props.commentValue }
                    selectedCategory={this.props.selectedCategory}/>
            );
        }

        var photoButton = null;
        var photoList = null;
        if (this.props.hasPhotoAttribute) {
            var photo = this.props.photoValue;
            if (photo && (photo.length > 0)) {
                photoList = <CargoPhotoList photo={ photo }/>
            } else {
                photoButton = <CargoPhotoControl photo={ photo }/>;
            }
        }

        return (
            <div className="CommonCargoAttributesPane">
                <div className="CommonCargoAttributesPane-title">{ title }</div>
                <div className="CommonCargoAttributesPane-controls">
                    { photoButton }
                    { commentButton }
                    { photoList }
                </div>
                { description }
            </div>
        );
    };
}

export default CommonCargoAttributesPane;



// WEBPACK FOOTER //
// ./client/components/CommonCargoAttributesPane/CommonCargoAttributesPane.js